export default {
    signature: 'qv-mask',

    handle(node) {

        if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'INPUT') {
            return null
        }

        const maskExpression = node.getAttribute(this.signature)

        if (!maskExpression) {
            return null
        }

        // Define regex patterns for mask characters
        const regexes = {
            9: /[0-9]/, // Digits only
            a: /[a-zA-Z]/, // Letters only
            '*': /[a-zA-Z0-9]/, // Alphanumeric
        }

        let lastInputValue = ''

        const templateFunction = () => maskExpression

        // Preprocess input value to remove unwanted prefixes for phone numbers
        function preprocessPhoneNumber(value, template) {

            // Only process for phone number masks
            if (template === '(999) 999-9999') {

                // Remove +1 prefix and any non-digit characters
                const digits = value.replace(/\D/g, '')

                // If starts with country code 1, remove it
                if (digits.startsWith('1') && digits.length > 10) {
                    return digits.substring(1)
                }

                return digits

            }

            return value

        }

        // Process the input value with the mask
        function processInputValue(element, shouldRestoreCursor = true) {

            let input = element.value

            const template = templateFunction(input)

            // If template is falsy, don't process
            if (!template || template === 'false') {
                return false
            }

            // Preprocess input for phone numbers to handle country codes
            input = preprocessPhoneNumber(input, template)

            // If they hit backspace, don't process input
            if (lastInputValue.length - element.value.length === 1) {
                return lastInputValue = element.value
            }

            const setInput = () => {
                lastInputValue = element.value = formatInput(template, input)
            }

            if (shouldRestoreCursor) {

                restoreCursorPosition(element, template, () => {
                    setInput()
                })

            } else {
                setInput()
            }

        }

        // Format the input according to the mask template
        function formatInput(template, input) {

            let output = ''
            let imark = 0
            let tmark = 0

            while (tmark < template.length && imark < input.length) {

                const char = template[ tmark ]
                const ichar = input[ imark ]

                if (char in regexes) {

                    if (regexes[ char ].test(ichar)) {

                        output += ichar
                        tmark++

                    }

                    imark++

                } else {

                    output += char
                    tmark++

                    if (char === input[ imark ]) {
                        imark++
                    }

                }

            }

            return output

        }

        // Restore cursor position after formatting
        function restoreCursorPosition(element, template, callback) {

            const cursorPosition = element.selectionStart
            const unformattedValue = element.value

            callback()

            const beforeLeftOfCursorBeforeFormatting = unformattedValue.slice(0, cursorPosition)

            const newPosition = formatInput(
                template, beforeLeftOfCursorBeforeFormatting,
            ).length

            element.setSelectionRange(newPosition, newPosition)

        }

        // Init
        const initialValue = node.value

        processInputValue(node, false)

        // If the value was formatted during init, dispatch input event to update model bindings
        if (node.value !== initialValue) {
            node.dispatchEvent(new Event('input', { bubbles: true }))
        }

        // Add input event listener
        const handleInput = () => processInputValue(node, true)
        const handleBlur = () => processInputValue(node, false)

        node.addEventListener('input', handleInput, { capture: true })
        node.addEventListener('change', handleInput, { capture: true })
        node.addEventListener('blur', handleBlur)

        // Return cleanup function
        return () => {

            node.removeEventListener('input', handleInput, { capture: true })
            node.removeEventListener('change', handleInput, { capture: true })
            node.removeEventListener('blur', handleBlur)

        }

    },
}
